var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.2871H10.775C10.275 12.2871 9.8 12.4808 9.45 12.8308L8.38125 13.8871C7.89375 14.3684 7.1 14.3684 6.6125 13.8871L5.54375 12.8308C5.19375 12.4808 4.7125 12.2871 4.21875 12.2871H3.75C2.7125 12.2871 1.875 11.4559 1.875 10.4309V3.61209C1.875 2.58709 2.7125 1.75586 3.75 1.75586H11.25C12.2875 1.75586 13.125 2.58709 13.125 3.61209V10.4309C13.125 11.4496 12.2875 12.2871 11.25 12.2871Z",
    stroke: "#EFFEF5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 6.22621C4.375 5.64496 4.85 5.16992 5.43125 5.16992C6.0125 5.16992 6.4875 5.64496 6.4875 6.22621C6.4875 7.40121 4.81875 7.52621 4.45 8.64496C4.375 8.87621 4.56875 9.10745 4.8125 9.10745H6.4875",
    stroke: "#EFFEF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0246 9.10053V5.5318C10.0246 5.3693 9.91836 5.22552 9.76211 5.18177C9.60586 5.13802 9.43711 5.20052 9.34961 5.33802C8.89961 6.06302 8.41211 6.88802 7.98711 7.61302C7.91836 7.73177 7.91836 7.88803 7.98711 8.00678C8.05586 8.12553 8.18711 8.20049 8.33086 8.20049H10.6246",
    stroke: "#EFFEF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketActive);
export default __webpack_public_path__ + "static/media/ticket-active.6a91b14fc4218af98a7320b22b63eb9c.svg";
export { ForwardRef as ReactComponent };